import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

export enum CacheDataTypes {
  show = 'show',
}

@Injectable({ providedIn: 'root' })
export class CacheService {
  private http = inject(HttpClient);

  private cache: Map<string, Observable<any>> = new Map();

  getCacheKey(type: CacheDataTypes, id: number): string {
    return `${type}-${id}`;
  }

  cacheRequest<T>(key: string, url: string): Observable<T> {
    if (!this.cache.has(key)) {
      const obs = this.http.get<T>(url).pipe(shareReplay(1));
      this.cache.set(key, obs);
    }
    return this.cache.get(key);
  }

  removeCacheFor(key: string): boolean {
    return this.cache.delete(key);
  }

  dropCache(): void {
    this.cache = new Map();
  }
}
